import { type FC } from 'react';

import { useCustomStyles } from './LinedWave.styles';

type Props = { isFlipped?: boolean; className?: string };

export const LinedWave: FC<Props> = ({ isFlipped, className }) => {
	const { classes, cx } = useCustomStyles();

	return (
		<svg
			className={cx(classes.wave, { [classes.flipped]: isFlipped }, className)}
			viewBox="0 0 1440 112"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_1573_135515)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0 86.4L60 64.8C120 43.2 240 0 360 0C480 0 600 43.2 720 57.6C840 72 960 57.6 1080 43.2C1200 28.8 1320 14.4 1380 7.2L1440 0V112H1380C1320 112 1200 112 1080 112C960 112 840 112 720 112C600 112 480 112 360 112C240 112 120 112 60 112H0V86.4Z"
					fill="#FBD684"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M0 99.4L60 77.8C120 56.2 240 13 360 13C480 13 600 56.2 720 70.6C840 85 960 70.6 1080 56.2C1200 41.8 1320 27.4 1380 20.2L1440 13V125H1380C1320 125 1200 125 1080 125C960 125 840 125 720 125C600 125 480 125 360 125C240 125 120 125 60 125H0V99.4Z"
					fill="#FEF1D6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1573_135515">
					<rect width="1440" height="112" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
